<template>
  <div>
    <div class="p-box">
      <div v-if="!loading" class="p-box__body">
        <Info>
          {{ $t('pages.companies.management.productCategories.info') }}
          <router-link :to="{ name: 'CompaniesProducts', params: { companyUuid: currentCompanyUuid } }">
            {{ $t('pages.companies.management.productCategories.infoLink') }}
          </router-link>
        </Info>
        <div v-show="productCategories && productCategories.length !== 0">
          <div class="p-table__content">
            <table>
              <thead>
                <tr>
                  <th><span>{{ $t('models.productCategory.modelName') }}</span></th>
                  <th />
                </tr>
                <tr class="p-table__content__space"><td colspan="5" /></tr>
              </thead>
              <tbody>
                <tr v-for="productCategory in productCategories" :key="productCategory.id">
                  <td class="u-fwB">{{ productCategory.name }}</td>
                  <td>
                    <div class="flexContainer">
                      <router-link :to="{ name: 'CompaniesProductCategoryEdit', params: { company_uuid: currentCompanyUuid, product_category_id: productCategory.id }}" class="action">
                        <img :src="imgIconPencil" alt="" class="action__icon">
                        {{ $t('labels.edit') }}
                      </router-link>
                      <a class="action" @click="onClickDeleteProductCategory(productCategory)">
                        <img :src="imgIconCross" alt="" class="action__icon">
                        {{ $t('labels.delete') }}
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p v-show="!productCategories || productCategories.length == 0">{{ $t('messages.notRegistered', { value: $t('models.productCategory.modelName') }) }}</p>
        <div class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesProductCategoryNew', params: { company_uuid: currentCompanyUuid }, query: { currentTab: 'ProductCategory' } }" class="c-button__item c-button__item--primary">{{ $t('labels.add', { value: $t('models.productCategory.modelName') }) }}</router-link>
        </div>
      </div>
      <Loading v-show="loading" />
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import Loading from '../../../components/Loading'
import ImgIconPencil from '../../../../../images/common/icon_pencil.svg'
import ImgIconCross from '../../../../../images/common/icon_cross.svg'
import Info from '../../../components/Info'

export default {
  name: 'CompaniesManagementProductCategories',
  components: {
    Info,
    Loading,
  },
  computed: {
    ...mapState({
      productCategories: state => state.companiesProductCategories.data,
      loading: state => state.companiesProductCategories.loading,
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    imgIconPencil: () => ImgIconPencil,
    imgIconCross: () => ImgIconCross
  },
  created() {
    this.readProductCategories()
  },
  methods: {
    ...mapActions({
      readProductCategories: 'companiesProductCategories/readProductCategories',
      deleteProductCategory: 'companiesProductCategories/deleteProductCategory',
    }),
    onClickDeleteProductCategory(productCategory) {
      if (!productCategory.canDelete) {
        return alert(this.$t('pages.companies.management.productCategories.AlertToDelete'))
      }

      if (confirm(this.$t('messages.confirmToDelete'))) {
        this.deleteProductCategory(productCategory.id)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.flexContainer {
  display: flex;
  justify-content: flex-end;
}
.action {
  display: flex;
  align-items: flex-start;
  margin-right: 24px;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
  &__icon {
    width: 18px;
    margin-right: 8px;
    img {
      display: block;
      width: 100%;
    }
  }
}
.p-table__content tbody th:not(:first-child), .p-table__content tbody td:not(:first-child) {
  border-left: none;
}
</style>
